import * as React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { batch } from "@preact/signals-react"

import { WEBBACK_V2_API } from "@constants"
import { skuGroup, sku } from "@signals"


export default function CommonFiltersSkuGroup({ ...props }) {
    return <AutocompleteAjaxSeeker
        urlAjax={`${WEBBACK_V2_API}/master-data/sku-group/options`}
        label="SKU Group"
        value={skuGroup.value}
        placeholder="Select SKUs Group"
        onChange={ e => batch(() => {
            const newValue = e.target.value
            skuGroup.value = newValue
            if (newValue === null)
                sku.value = []
        })}
        {...props}
    />
}